"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlienClient = void 0;
const websocket_1 = require("websocket");
const client_event_enum_1 = require("./enum/client-event.enum");
const pm_withdraw_calculation_info_message_interface_1 = require("./enum/pm-withdraw-calculation-info-message.interface");
let ackId = 1000000;
class AlienClient {
    constructor() {
        this._connectionType = 'pubsub';
    }
    onInit(callback) {
        this._onInit = callback;
    }
    onB2cInit(callback) {
        this._onB2cInit = callback;
    }
    onB2cUpdate(callback) {
        this._onB2cUpdate = callback;
    }
    onNotification(callback) {
        this._onNotification = callback;
    }
    onPong(callback) {
        this._onPong = callback;
    }
    onError(callback) {
        this._onError = callback;
    }
    onOpen(callback) {
        this._onOpen = callback;
    }
    onClose(callback) {
        this._onClose = callback;
    }
    onGetCurrenciesResponse(callback) {
        this._onGetCurrenciesResponse = callback;
    }
    onDisconnected(callback) {
        this._onDisconnected = callback;
    }
    onGetSupportResponse(callback) {
        this._onGetSupportResponse = callback;
    }
    onGetPlayerWalletResponse(callback) {
        this._onGetPlayerWalletResponse = callback;
    }
    onGetBetsResponse(callback) {
        this._onGetBetsResponse = callback;
    }
    onGetTransactionsResponse(callback) {
        this._onGetTransactionsResponse = callback;
    }
    // b2c 
    OnGetB2cTransactionsResponse(callback) {
        this._onGetB2cTransactionsResponse = callback;
    }
    // b2c 
    OnGetB2cBetsResponse(callback) {
        this._onGetB2cBetsResponse = callback;
    }
    // b2c 
    onAddPmWithdrawResponse(callback) {
        this._onAddPMWithdrawResponse = callback;
    }
    // b2c
    onAddPmVoucherDepositResponse(callback) {
        this._onAddPMVoucherDepositResponse = callback;
    }
    // b2c
    onAddCryptoDepositResponse(callback) {
        this._onAddCryptoDepositResponse = callback;
    }
    // b2c
    onAddCryptoWithdrawResponse(callback) {
        this._onAddCryptoWithdrawResponse = callback;
    }
    // b2c
    onAddCryptoCheckResponse(callback) {
        this._onAddCryptoCheckResponse = callback;
    }
    // b2c
    onAddMiniPayDepositResponse(callback) {
        this._onAddMiniPayDepositResponse = callback;
    }
    // b2c
    onAddMiniPayWithdrawResponse(callback) {
        this._onAddMiniPayWithdrawResponse = callback;
    }
    onGetPaymentUrlResponse(callback) {
        this._onGetPaymentUrlResponse = callback;
    }
    onGetUploadUrlResponse(callback) {
        this._onGetUploadUrlResponse = callback;
    }
    onGetChatConnectionInfoResponse(callback) {
        this._onGetChatConnectionInfoResponse = callback;
    }
    onVerifyPaymentResponse(callback) {
        this._onVerifyPaymentResponse = callback;
    }
    onGetGameLaunchResponse(callback) {
        this._onGetGameLaunchResponse = callback;
    }
    onSetActiveCurrencyResponse(callback) {
        this._onSetActiveCurrencyResponse = callback;
    }
    onSetActiveLanguageResponse(callback) {
        this._onSetActiveLanguageResponse = callback;
    }
    onCloseGameResponse(callback) {
        this._onCloseGameResponse = callback;
    }
    onSetUiStateResponse(callback) {
        this._onSetUiStateResponse = callback;
    }
    onGetUiStateResponse(callback) {
        this._onGetUiStateResponse = callback;
    }
    onAddCpgWithdrawResponse(callback) {
        this._onAddCpgWithdrawResponse = callback;
    }
    onAddPwWithdrawResponse(callback) {
        this._onAddPwWithdrawResponse = callback;
    }
    onGetPmWithdrawCalculationsResponse(callback) {
        this._onGetPMWithdrawCalculationsResponse = callback;
    }
    onAddJbWithdrawResponse(callback) {
        this._onAddJbWithdrawResponse = callback;
    }
    onCancelWithdrawResponse(callback) {
        this._onCancelWithdrawResponse = callback;
    }
    onAddKycVerificationFileResponse(callback) {
        this._onAddKycVerificationFileResponse = callback;
    }
    onDeleteKycVerificationFileResponse(callback) {
        this._onDeleteKycVerificationFileResponse = callback;
    }
    onPlayerNicknameChange(callback) {
        this._onPlayerNicknameChange = callback;
    }
    processMessages(message) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('PKG::received message::', message);
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.init) {
                const initInfo = message.data;
                this._initInfo = initInfo;
                this._awpsGroupName = initInfo.group;
                if (!this._onInit)
                    return;
                return this._onInit(initInfo);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.b2cInit) {
                const b2cInitInfo = message.data;
                this._b2cInitInfo = b2cInitInfo;
                this._awpsGroupName = b2cInitInfo.group;
                if (!this._onB2cInit)
                    return;
                return this._onB2cInit(b2cInitInfo);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.b2cUpdate) {
                const b2cInitInfo = message.data;
                this._b2cInitInfo = b2cInitInfo;
                this._awpsGroupName = b2cInitInfo.group;
                if (!this._onB2cUpdate)
                    return;
                return this._onB2cUpdate(b2cInitInfo);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.notification) {
                if (!this._onNotification)
                    return;
                const notification = message.data;
                return this._onNotification(notification);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.pong) {
                if (!this._onPong)
                    return;
                const messageData = message.data;
                const pong = messageData;
                return this._onPong(pong);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getCurrenciesResponse) {
                if (!this._onGetCurrenciesResponse)
                    return;
                const messageData = message.data;
                const onGetCurrenciesResponseParams = messageData;
                return this._onGetCurrenciesResponse(onGetCurrenciesResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.disconnected) {
                if (!this._onDisconnected)
                    return;
                const messageData = message.data;
                const onDisconnectedParams = messageData;
                return this._onDisconnected(onDisconnectedParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getSupportResponse) {
                if (!this._onGetSupportResponse)
                    return;
                const messageData = message.data;
                const onGetSupportResponseParams = messageData;
                return this._onGetSupportResponse(onGetSupportResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getPlayerWalletResponse) {
                if (!this._onGetPlayerWalletResponse)
                    return;
                const messageData = message.data;
                const onGetPlayerWalletResponseParams = messageData;
                return this._onGetPlayerWalletResponse(onGetPlayerWalletResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getBetsResponse) {
                if (!this._onGetBetsResponse)
                    return;
                const messageData = message.data;
                const onGetBetsResponseParams = messageData;
                return this._onGetBetsResponse(onGetBetsResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getTransactionsResponse) {
                if (!this._onGetTransactionsResponse)
                    return;
                const messageData = message.data;
                const onGetTransactionsResponseParams = messageData;
                return this._onGetTransactionsResponse(onGetTransactionsResponseParams);
            }
            // b2c
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getB2cTransactionsResponse) {
                if (!this._onGetB2cTransactionsResponse)
                    return;
                const messageData = message.data;
                const onGetB2cTransactionsResponseParams = messageData;
                return this._onGetB2cTransactionsResponse(onGetB2cTransactionsResponseParams);
            }
            // b2c
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getB2cBetsResponse) {
                if (!this._onGetB2cBetsResponse)
                    return;
                const messageData = message.data;
                const onGetB2cBetsResponseParams = messageData;
                return this._onGetB2cBetsResponse(onGetB2cBetsResponseParams);
            }
            // b2c
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addPmVoucherDepositResponse) {
                if (!this._onAddPMVoucherDepositResponse)
                    return;
                const messageData = message.data;
                const onAddPmVoucherDepositResponseParams = messageData;
                return this._onAddPMVoucherDepositResponse(onAddPmVoucherDepositResponseParams);
            }
            // b2c 
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addB2cCryptoDepositResponse) {
                if (!this._onAddCryptoDepositResponse)
                    return;
                const messageData = message.data;
                const onAddCryptoDepositResponseParams = messageData;
                return this._onAddCryptoDepositResponse(onAddCryptoDepositResponseParams);
            }
            // b2c 
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addB2cMiniPayDepositResponse) {
                if (!this._onAddMiniPayDepositResponse)
                    return;
                const messageData = message.data;
                const onAddMiniPayDepositResponseParams = messageData;
                return this._onAddMiniPayDepositResponse(onAddMiniPayDepositResponseParams);
            }
            // b2c 
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addB2cMiniPayWithdrawResponse) {
                if (!this._onAddMiniPayWithdrawResponse)
                    return;
                const messageData = message.data;
                const onAddMiniPayWithdrawResponseParams = messageData;
                return this._onAddMiniPayWithdrawResponse(onAddMiniPayWithdrawResponseParams);
            }
            // b2c 
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addB2cCryptoWithdrawResponse) {
                if (!this._onAddCryptoWithdrawResponse)
                    return;
                const messageData = message.data;
                const onAddCryptoWithdrawResponseParams = messageData;
                return this._onAddCryptoWithdrawResponse(onAddCryptoWithdrawResponseParams);
            }
            // b2c 
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addB2cCryptoCheckResponse) {
                if (!this._onAddCryptoCheckResponse)
                    return;
                const messageData = message.data;
                const onAddCryptoCheckResponseParams = messageData;
                return this._onAddCryptoCheckResponse(onAddCryptoCheckResponseParams);
            }
            // b2c
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addPmWithdrawResponse) {
                if (!this._onAddPMWithdrawResponse)
                    return;
                const messageData = message.data;
                const onAddPmWithdrawResponseParams = messageData;
                return this._onAddPMWithdrawResponse(onAddPmWithdrawResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getPaymentUrlResponse) {
                if (!this._onGetPaymentUrlResponse)
                    return;
                const messageData = message.data;
                const onGetPaymentUrlResponseParams = messageData;
                return this._onGetPaymentUrlResponse(onGetPaymentUrlResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getUploadUrlResponse) {
                if (!this._onGetUploadUrlResponse)
                    return;
                const messageData = message.data;
                const onGetUploadUrlResponseParams = messageData;
                return this._onGetUploadUrlResponse(onGetUploadUrlResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getChatConnectionInfoResponse) {
                if (!this._onGetChatConnectionInfoResponse)
                    return;
                const messageData = message.data;
                const onGetChatConnectionInfoResponseParams = messageData;
                return this._onGetChatConnectionInfoResponse(onGetChatConnectionInfoResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.verifyPaymentResponse) {
                if (!this._onVerifyPaymentResponse)
                    return;
                const messageData = message.data;
                const onVerifyPaymentResponseParams = messageData;
                return this._onVerifyPaymentResponse(onVerifyPaymentResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getGameLaunchResponse) {
                if (!this._onGetGameLaunchResponse)
                    return;
                const messageData = message.data;
                const onGetGameLaunchResponseParams = messageData;
                return this._onGetGameLaunchResponse(onGetGameLaunchResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.setActiveCurrencyResponse) {
                if (!this._onSetActiveCurrencyResponse)
                    return;
                const messageData = message.data;
                const onSetActiveCurrencyResponseParams = messageData;
                return this._onSetActiveCurrencyResponse(onSetActiveCurrencyResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.setActiveLanguageResponse) {
                if (!this._onSetActiveLanguageResponse)
                    return;
                const messageData = message.data;
                const onSetActiveLanguageResponseParams = messageData;
                return this._onSetActiveLanguageResponse(onSetActiveLanguageResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.closeGameResponse) {
                if (!this._onCloseGameResponse)
                    return;
                const messageData = message.data;
                const onCloseGameResponseParams = messageData;
                return this._onCloseGameResponse(onCloseGameResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.setUiStateResponse) {
                if (!this._onSetUiStateResponse)
                    return;
                const messageData = message.data;
                const onSetUiStateResponseParams = messageData;
                return this._onSetUiStateResponse(onSetUiStateResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getUiStateResponse) {
                if (!this._onGetUiStateResponse)
                    return;
                const messageData = message.data;
                const onGetUiStateResponseParams = messageData;
                return this._onGetUiStateResponse(onGetUiStateResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addCpgWithdrawResponse) {
                if (!this._onAddCpgWithdrawResponse)
                    return;
                const messageData = message.data;
                const onAddCpgWithdrawResponseParams = messageData;
                return this._onAddCpgWithdrawResponse(onAddCpgWithdrawResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addPwWithdrawResponse) {
                if (!this._onAddPwWithdrawResponse)
                    return;
                const messageData = message.data;
                const onAddPwWithdrawResponseParams = messageData;
                return this._onAddPwWithdrawResponse(onAddPwWithdrawResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.getPmWithdrawCalculationsResponse) {
                if (!this._onGetPMWithdrawCalculationsResponse)
                    return;
                const messageData = message.data;
                const onAddPwWithdrawResponse = messageData;
                return this._onGetPMWithdrawCalculationsResponse(onAddPwWithdrawResponse);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addJbWithdrawResponse) {
                if (!this._onAddJbWithdrawResponse)
                    return;
                const messageData = message.data;
                const onAddJbWithdrawResponseParams = messageData;
                return this._onAddJbWithdrawResponse(onAddJbWithdrawResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.cancelWithdrawResponse) {
                if (!this._onCancelWithdrawResponse)
                    return;
                const messageData = message.data;
                const onCancelWithdrawResponseParams = messageData;
                return this._onCancelWithdrawResponse(onCancelWithdrawResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.addKycVerificationFileResponse) {
                if (!this._onAddKycVerificationFileResponse)
                    return;
                const messageData = message.data;
                const onAddKycVerificationFileResponseParams = messageData;
                return this._onAddKycVerificationFileResponse(onAddKycVerificationFileResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.deleteKycVerificationFileResponse) {
                if (!this._onDeleteKycVerificationFileResponse)
                    return;
                const messageData = message.data;
                const onDeleteKycVerificationFileResponseParams = messageData;
                return this._onDeleteKycVerificationFileResponse(onDeleteKycVerificationFileResponseParams);
            }
            if ((message === null || message === void 0 ? void 0 : message.event) === client_event_enum_1.ClientEvents.playerNicknameChange) {
                if (!this._onPlayerNicknameChange)
                    return;
                const messageData = message.data;
                const onPlayerNicknameChangeParams = messageData;
                return this._onPlayerNicknameChange(onPlayerNicknameChangeParams);
            }
        });
    }
    connect(params) {
        return __awaiter(this, void 0, void 0, function* () {
            // To support old codes
            if (!(params === null || params === void 0 ? void 0 : params.token)) {
                const token = params.toString();
                yield this.connectByAwps({ token });
                return;
            }
            const { token, connectionType, subscribeKey, channelName, publishKey, playerFullId, options, } = params;
            this._connectionType = connectionType;
            if (connectionType === 'pubnub') {
                yield this.connectByPubNub({
                    token,
                    channelName,
                    subscribeKey,
                    publishKey,
                    playerFullId,
                    options,
                });
            }
            else {
                yield this.connectByAwps({
                    token,
                    options
                });
            }
        });
    }
    connectByAwps(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { token, options } = params;
            const WebSocket = websocket_1.w3cwebsocket;
            this._awpsSocket = new WebSocket(token, 'json.webpubsub.azure.v1');
            this._awpsSocket.onerror = (awpsEvent) => __awaiter(this, void 0, void 0, function* () {
                if (this._onError)
                    this._onError(awpsEvent);
            });
            this._awpsSocket.onclose = (awpsEvent) => __awaiter(this, void 0, void 0, function* () {
                this._awpsSocket = undefined;
                if (this._onClose)
                    this._onClose(awpsEvent);
            });
            this._awpsSocket.onopen = () => __awaiter(this, void 0, void 0, function* () {
                if (this._onOpen)
                    this._onOpen();
            });
            this._awpsSocket.onmessage = (awpsEvent) => __awaiter(this, void 0, void 0, function* () {
                const messageInfo = JSON.parse(awpsEvent.data);
                let message = messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.data;
                this.processMessages(message);
            });
        });
    }
    connectByPubNub(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { token, channelName, subscribeKey, publishKey, playerFullId, options, } = params;
            this._channelName = channelName;
            const pubnub = require('pubnub');
            this._pubnub = new pubnub({
                subscribeKey,
                publishKey,
                userId: channelName,
            });
            // this._awpsSocket.onerror = async (awpsEvent) => {
            //     if (this._onError) this._onError(awpsEvent);
            // }
            // this._awpsSocket.onclose = async (awpsEvent) => {
            //     this._awpsSocket = undefined;
            //     if (this._onClose) this._onClose(awpsEvent);
            // }
            // this._awpsSocket.onopen = async () => {
            //     if (this._onOpen) this._onOpen();
            // }
            this._pubnub.setToken(token);
            this._pubnub.subscribe({ channels: [channelName] });
            this._pubnub.unsubscribe({ channels: [channelName] });
            const listener = {
                message: (messageEvent) => {
                    this.processMessages(messageEvent === null || messageEvent === void 0 ? void 0 : messageEvent.message);
                },
            };
            this._pubnub.addListener(listener);
            this._pubnub.subscribe({ channels: [channelName] });
        });
    }
    sendMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._connectionType === 'pubnub') {
                const publishResult = yield this._pubnub.publish({
                    channel: this._channelName,
                    message: message,
                    sendByPost: true
                });
                // console.log('PKG::send message::', this._channelName, message);
                // console.log('PKG::publishResult::', publishResult);
            }
            else {
                if (!this._awpsSocket) {
                    throw 'AWPS is not connected.';
                }
                if (!this._awpsGroupName) {
                    throw 'AWPS group is not valid.';
                }
                this._awpsSocket.send(JSON.stringify({
                    type: "sendToGroup",
                    group: this._awpsGroupName,
                    ackId: ackId++,
                    noEcho: true,
                    dataType: "json",
                    data: message
                }));
            }
        });
    }
    disconnect(traceData) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = {
                event: client_event_enum_1.ClientEvents.disconnect,
                traceData,
                data: {}
            };
            this.sendMessage(message);
        });
    }
    ping(dto, traceData) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = {
                event: client_event_enum_1.ClientEvents.ping,
                traceData,
                data: dto
            };
            this.sendMessage(message);
        });
    }
    getCurrencies(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getCurrenciesRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getSupport(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getSupportRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getPlayerWallet(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getPlayerWalletRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getBets(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getBetsRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getB2cBets(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getB2cBetsRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getPmCalculations(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getPmWithdrawCalculationsRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getTransactions(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getTransactionsRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getTransactionsB2c(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getB2cTransactionsRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addPmVoucherDeposit(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addPmVoucherDepositRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addB2cCryptoDeposit(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addB2cCryptoDepositRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addB2cCryptoWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addB2cCryptoWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addB2cCryptoCheck(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addB2cCryptoCheckRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addB2cMiniPayDeposit(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addB2cMiniPayDepositRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addB2cMiniPayWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addB2cMiniPayWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getPaymentUrl(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getPaymentUrlRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getUploadUrl(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getUploadUrlRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getChatConnectionInfo(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getChatConnectionInfoRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    verifyPayment(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.verifyPaymentRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getGameLaunch(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getGameLaunchRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    setActiveCurrency(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.setActiveCurrencyRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    setActiveLanguage(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.setActiveLanguageRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    closeGame(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.closeGameRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    setUiState(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.setUiStateRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    getUiState(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.getUiStateRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addCpgWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addCpgWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addPwWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addPwWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addJbWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addJbWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addPmWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addPmWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    cancelWithdraw(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.cancelWithdrawRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    addKycVerificationFile(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.addKycVerificationFileRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    deleteKycVerificationFile(dto, traceData) {
        const message = {
            event: client_event_enum_1.ClientEvents.deleteKycVerificationFileRequest,
            traceData,
            data: dto
        };
        this.sendMessage(message);
    }
    /**
     * Calculates withdrawal fees and provides detailed withdrawal calculations.
     *
     * @async
     * @function
     * @param {Object} params - Parameters for withdrawal fee calculations.
     * @param {number} [params.amount] - The withdrawal amount (optional).
     * @param {string} params.currency - The currency for withdrawal.
     * @returns {Promise<PmWithdrawRequestCalculationsResponse>} An object containing withdrawal calculations and success status.
     * @throws {Error} If an error occurs during the withdrawal fee calculations.
     *
     * @example
     * // Usage example:
     * const withdrawalParams = {
     *   amount: 1000,
     *   currency: 'IRT'
     * };
     * const withdrawalResult = await withdrawFeesCalculations(withdrawalParams);
     * console.log(withdrawalResult);
     */
    withdrawFeesCalculations(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            //INIT the res
            const response = {
                success: false,
                status: pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.INTERNAL_ERROR,
            };
            try {
                let initData = this._b2cInitInfo;
                const { amount, currency } = params;
                const player = initData.player;
                const currencyDetails = initData.currencies[currency];
                console.log("b2c Init Info DATA : ");
                console.log(initData);
                // GET LIVE CONVERSION RATE
                const rate = currencyDetails.oneUSD;
                // Get Payment Gateway Details 
                const paymentGateway = (_a = initData === null || initData === void 0 ? void 0 : initData.paymentGateways) === null || _a === void 0 ? void 0 : _a.PM;
                if (!player) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.PLAYER_NOT_FOUND;
                    return response;
                }
                // Validate Payment Gateway status 
                if (!paymentGateway) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.PAYMENT_GATEWAY_INACTIVE;
                    return response;
                }
                if (!paymentGateway.isActive || !paymentGateway.enableToWithdraw || !paymentGateway.isVisible) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.PAYMENT_GATEWAY_INACTIVE;
                    return response;
                }
                // Get Payment Gateway settings 
                const paymentGatewaySettings = paymentGateway.settings.withdraw[currency];
                // Get Platform settings for this Gateway  
                const platformSettings = paymentGateway.generalConfig.withdraw[currency];
                if (!player.wallet.byCurrency[currency]) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.WALLET_NOT_FOUND;
                    return response;
                }
                if (!player.wallet.byCurrency[currency].balance) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.NOT_ENOUGH_BALANCE;
                    return response;
                }
                if (platformSettings.minAmount > amount) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.AMOUNT_IS_NOT_VALID;
                    return response;
                }
                const oldWallet = player.wallet.byCurrency[currency].balance;
                const yourBalanceInUsD = oldWallet / rate;
                // GET THE TOTAL fees
                const totalFee = this.calculateFees({
                    amount,
                    platformFixedRate: platformSettings.platformConversionFixedRate,
                    platformRate: platformSettings.platformConversionPercentageRate,
                    pmFixedRate: paymentGatewaySettings.eVoucherConversionFixedRate,
                    pmRate: paymentGatewaySettings.eVoucherConversionPercentageRate,
                });
                if (amount > yourBalanceInUsD) {
                    response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.NOT_ENOUGH_BALANCE;
                    return response;
                }
                const paymentGatewayFees = this.calculateFees({
                    amount,
                    platformFixedRate: 0,
                    platformRate: 0,
                    pmFixedRate: paymentGatewaySettings.eVoucherConversionFixedRate,
                    pmRate: paymentGatewaySettings.eVoucherConversionPercentageRate,
                });
                const systemFees = this.calculateFees({
                    amount,
                    platformFixedRate: platformSettings.platformConversionFixedRate,
                    platformRate: platformSettings.platformConversionPercentageRate,
                    pmFixedRate: 0,
                    pmRate: 0,
                });
                const data = {
                    playerBalanceInUSD: yourBalanceInUsD,
                    playerBalanceByCurrency: oldWallet,
                    exChangeRate: rate,
                    targetCurrency: 'USD',
                    fromCurrency: currency,
                    maxAmountPlayerCanWithdraw: {
                        ['USD']: {
                            amount: yourBalanceInUsD - totalFee,
                        },
                        [currency]: {
                            amount: oldWallet - totalFee * rate,
                        },
                    },
                    withdrawFees: {
                        USD: {
                            fees: totalFee,
                        },
                        [currency]: {
                            fees: totalFee * rate,
                        },
                    },
                    playerWillGet: amount - totalFee,
                    newWalletByTargetCurrency: oldWallet - amount * rate,
                    newWalletInUSD: yourBalanceInUsD - amount,
                    feesDetails: {
                        USD: {
                            paymentGatewayFees: paymentGatewayFees,
                            systemFees: systemFees,
                            total: totalFee,
                        },
                        [currency]: {
                            paymentGatewayFees: paymentGatewayFees * rate,
                            systemFees: systemFees * rate,
                            total: totalFee * rate,
                        },
                    },
                };
                response.data = data;
                response.success = true;
                response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.OK;
            }
            catch (error) {
                console.log("Error in withdraw Fees Calculations");
                console.log(error);
                response.success = true;
                response.status = pm_withdraw_calculation_info_message_interface_1.PmWithdrawCalculationsStatus.INTERNAL_ERROR;
            }
            finally {
                return response;
            }
        });
    }
    /**
     * Calculates withdrawal fees based on the given Formula.
     * @private
     * @function
     * @param {Object} params - Parameters for withdrawal fee calculations.
     * @param {number} params.pmFixedRate - Payment gateway's fixed rate for withdrawal.
     * @param {number} params.pmRate - Payment gateway's percentage rate for withdrawal.
     * @param {number} params.platformFixedRate - Platform's fixed rate for withdrawal.
     * @param {number} params.platformRate - Platform's percentage rate for withdrawal.
     * @param {number} params.amount - The withdrawal amount.
     * @returns {number} The total withdrawal fees.
     *
     * @example
     * // Usage example:
     * const feeParams = {
     *   pmFixedRate: 10,
     *   pmRate: 2,
     *   platformFixedRate: 5,
     *   platformRate: 1,
     *   amount: 1000
     * };
     * const totalFees = calculateFees(feeParams);
     * console.log(totalFees);
     */
    calculateFees(params) {
        // [INFO :SALI] totalWithdrawFee = paymentGatewayWithdrawFixedFee + operatorWithdrawFixedFee + ((operatorWithdrawPercentageFee * withdrawAmount)/100) + ((paymentGatewayWithdrawPercentageFee * withdrawAmount) /100)
        const { amount, platformFixedRate, platformRate, pmFixedRate, pmRate } = params;
        return (pmFixedRate +
            platformFixedRate +
            (platformRate * amount) / 100 +
            (pmRate * amount) / 100);
    }
}
exports.AlienClient = AlienClient;
